import { get } from 'lodash';
import { IHydrateWidgetInput } from '../../../../../../hydrate/IHydrationContext';
import { IBaseWidget } from '../../../../IBaseWidget';
import { getAsyncServiceLabel } from '../components/label/getSelectedValueLabel';
import { asyncSelectWidgetObjectName } from '../hooks/asyncSelectObjectName';
import { IAsyncSelectWidget } from '../IAsyncSelectWidget';

/**
 * Funzione per l'estrazione dell'idratazione centralizzata per i widget async (AsyncSelect e AsyncValue).
 */
export function hydrateAsyncWidget<
  W extends IBaseWidget &
    Pick<IAsyncSelectWidget, 'labelFields' | 'labelField'>,
>(input: IHydrateWidgetInput<W>) {
  const { context, path, widget } = input;
  try {
    // Recupero la chiave <path>@object
    const objectKey = asyncSelectWidgetObjectName(path);
    const values = get(context.values, objectKey);
    // Recupero il valore utilizzato come label
    const labelValue = getAsyncServiceLabel(widget.labelFields, values);

    // Lo ritorno, il campo andrà a sovrascrivere il valore ritornato.
    return {
      value: labelValue,
    };
  } catch (error) {
    console.error(`[Async Widget] Errore durante l'hydrate del widget ${path} (type: ${widget.type})`, { context, path, widget, error }); // prettier-ignore
    return {
      value: 'N/A',
    };
  }
}
